import React from 'react';
import { Link, To } from 'react-router-dom';
import { CellContext } from '@tanstack/table-core';

import { Typography } from '../../../../Typography';

export interface IIdentificationCellProps<RowData extends object> {
    cell: CellContext<RowData, any>;
    href?: To;
}

export const IdentificationCell = <RowData extends object>({ cell, href }: IIdentificationCellProps<RowData>) => {
    const content = (
        <Typography color="primary" fontWeight="bold">
            {cell.getValue()}
        </Typography>
    );

    if (href) {
        return <Link to={href}>{content}</Link>;
    }

    return content;
};
